import React from 'react';
import { Button, Modal } from '../../../../components';
import { ButtonVariantType } from '../../../../components/Button/Button';

type ConfirmationModalProps = {
  serviceName: string;
  incomingOperation: string;
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
};

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  serviceName,
  incomingOperation,
  onClose,
  onConfirm,
  open,
}: ConfirmationModalProps): JSX.Element => {
  const isClusterEngActionOnCheck =
    serviceName === 'Automatically Group New Threads' &&
    incomingOperation === 'OFF';

  const attrs = {
    Modal: {
      open,
      title: isClusterEngActionOnCheck ? 'Stop grouping new threads?' : '',
      centeredTitle: isClusterEngActionOnCheck,
      titleFontSize: isClusterEngActionOnCheck ? '16px' : '',
      onClose,
      width: isClusterEngActionOnCheck ? '546px' : '460px',
      className: `${
        isClusterEngActionOnCheck ? 'cluster-engagements' : ''
      } confirmation__modal`,
    },

    modalBody: {
      wrapper: {
        className: 'confirmation__org',
      },

      boldText: {
        className: 'confirmation__org-bold',
      },

      operation: {
        className: 'confirmation__operation',
      },
    },

    cluserEngagements: {
      className: 'confirmation-cluster-engagements',
    },

    buttons: {
      confirm: {
        onClick: onConfirm,
        className: `${
          isClusterEngActionOnCheck ? 'cluster-engagements' : ''
        } confirmation__btn`,
        variant:
          incomingOperation === 'ON'
            ? ('common' as ButtonVariantType)
            : ('text' as ButtonVariantType),
      },

      cancel: {
        onClick: onClose,
        className: `${isClusterEngActionOnCheck ? 'cluster-engagements' : ''} ${
          incomingOperation === 'ON' ? 'less-margin' : ''
        } confirmation__btn`,
        variant:
          incomingOperation === 'ON'
            ? ('text' as ButtonVariantType)
            : ('common' as ButtonVariantType),
      },
    },
  };

  const conditionalMessage =
    serviceName === 'Webhook' ? (
      <div {...attrs.modalBody.wrapper}>
        Are you sure you would like to turn the{' '}
        <span {...attrs.modalBody.boldText}>webhooks</span> {incomingOperation}?
      </div>
    ) : (
      <div {...attrs.modalBody.wrapper}>
        Are you sure you would like to turn{' '}
        <span {...attrs.modalBody.boldText}>{serviceName}</span>{' '}
        {incomingOperation}? This would turn it{' '}
        <span {...attrs.modalBody.operation}>{incomingOperation}</span> for all
        the users in your organization
      </div>
    );

  const defaultModalBody = isClusterEngActionOnCheck ? null : (
    <>
      {conditionalMessage}
      <Button {...attrs.buttons.cancel}>Cancel</Button>
      <Button {...attrs.buttons.confirm}>{`Turn ${incomingOperation}`}</Button>
    </>
  );

  const clusterEngagementsOnBody = isClusterEngActionOnCheck ? (
    <>
      <div {...attrs.cluserEngagements}>
        {`If you turn this off, Substrata won't group new threads from people
    you engage with. We highly recommend leaving this feature on so you can
    enjoy the best possible engagement analytics & recommendations.`}
      </div>
      <Button {...attrs.buttons.cancel}>Leave On</Button>
      <Button {...attrs.buttons.confirm}>Turn Off</Button>
    </>
  ) : null;

  return (
    <Modal {...attrs.Modal}>
      <>
        {defaultModalBody}
        {clusterEngagementsOnBody}
      </>
    </Modal>
  );
};
